import React, { useState } from 'react';
import bcrypt from 'bcryptjs';
import './PasswordProtection.css';
import { Helmet } from 'react-helmet-async';

const PasswordProtection = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  // The hashed password (this would normally be stored securely on a server)
  const hashedPassword = '$2b$10$wVPU2fUn8xCywJWQiPRUbOjQlIEVtcQAzAR8EcwOg38yNMGAOLEde'; // This is the hash for "weiofgruheboe"

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const isValid = await bcrypt.compare(password, hashedPassword);
      if (isValid) {
        setIsAuthenticated(true);
        setError('');
      } else {
        setError('Incorrect password');
      }
    } catch (err) {
      setError('An error occurred');
    }
  };

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="password-container">
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <form className="passwordForm" onSubmit={handleSubmit}>
        <h1 className="password-title">Enter Password</h1>
        
        <div className="form-group">
          <label>Password</label>
          {/* <div className="password-input-container"> */}
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
            />
            {/* <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="password-toggle"
            >
              {showPassword ? '👁️' : '👁️‍🗨️'}
            </button> */}
          {/* </div> */}
        </div>

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <button type="submit">Unlock</button>
      </form>
    </div>
  );
};

export default PasswordProtection; 